import { defaultColumns, defaultSort } from '../../components/sales/proformCustomerOrders/columns';

export default {
  state: {
    proformCustomerOrders: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    proformCustomerOrders: state => state.proformCustomerOrders,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setProformCustomerOrders(state, proformCustomerOrders) {
      state.proformCustomerOrders = proformCustomerOrders;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/proform-customer-order-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'proform-customer-order-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const proformCustomerOrders = await axios.get('api/proform-customer-orders' + (query || ''));
        commit('setProformCustomerOrders', proformCustomerOrders);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/proform-customer-orders/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/proform-customer-orders', payLoad);
    },
    async send({ commit }, id) {
      return await axios.post(`api/proform-customer-orders/finalize/${id}`);
    },
    async createCustomerOrder({ commit }, id) {
      return await axios.post(`api/proform-customer-orders/create-customer-order/${id}`);
    },
    async createInvoice({ commit }, payload) {
      return await axios.post(`api/proform-customer-orders/create-invoice/${payload.id}`, payload);
    },
    async update({ commit }, payload) {
      await axios.put(`api/proform-customer-orders/${payload.id}`, payload);
    },
    async cancel({ commit }, id) {
      return await axios.post(`api/proform-customer-orders/cancel/${id}`);
    },
    async undoCancel({ commit }, id) {
      return await axios.post(`api/proform-customer-orders/undo-cancel/${id}`);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/proform-customer-orders/${id}`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/proform-customer-order-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'ProformCustomerOrders'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
